import React from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";

type SpinnerType = {
  className?: string;
  color?: string;
  isMargin?: boolean;
};

const Spinner: React.FC<SpinnerType> = ({ className, color, isMargin }) => (
  <Spin
    indicator={
      <LoadingOutlined
        style={{
          fontSize: 18,
          color: color ?? "#fff",
          marginLeft: isMargin ? 20 : 0,
        }}
        spin
        className={className}
      />
    }
  />
);

export default Spinner;
